if (!customElements.get("complete-set-tabs")) {
  class CompleteSetTabs extends HTMLElement {
    constructor() {
      super();

      if (Shopify.designMode) {
        window.addEventListener("shopify:section:load", this.init.bind(this));
      }
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.tabs = this.querySelectorAll(".complete-set-tabs__tab");
      this.panels = this.querySelectorAll(".complete-set-tabs__panel");

      this.tabs.forEach((tab) => {
        tab.addEventListener("click", (e) => this.switchTab(e));
      });
    }

    switchTab(e) {
      const targetTab = e.currentTarget;
      const targetPanelId = targetTab.dataset.tab;

      // Remove active class from all tabs
      this.tabs.forEach((tab) => {
        tab.classList.remove("active");
      });

      // Remove active class from all panels
      this.panels.forEach((panel) => {
        panel.classList.remove("active");
      });

      // Add active class to clicked tab
      targetTab.classList.add("active");

      // Add active class to corresponding panel
      const targetPanel = this.querySelector(`#${targetPanelId}`);
      if (targetPanel) {
        targetPanel.classList.add("active");
      }
    }
  }

  customElements.define("complete-set-tabs", CompleteSetTabs);
}
